<template lang="pug">
//- v-menu(v-model='menu' :close-on-content-click='false' :nudge-width='200' offset-y='')
//-   template(v-slot:activator='{ on }')
//-     v-btn( v-on='on' color='primary')
//-       v-icon(size='30') palette
//-       span.ml-2  Cambiar tema
//-   v-card
//-     v-card-text
//-       v-card.my-2(:disabled='$vuetify.theme.themes.name === theme.name' @click='setTheme(theme)' hover='' outlined='' v-for='(theme, index) in themes' :key='index')
//-         v-list-item
//-           v-list-item-content
//-             v-list-item-title.font-weight-bold
//-               | {{ theme.name }}
//-           v-list-item-action
//-             v-avatar(color='success' size='30' v-if='$vuetify.theme.themes.name === theme.name')
//-               v-icon check
//-         .my-2
//-           v-chip.mx-1(label='' :color='theme.dark[key]' v-for='(key, index) in Object.keys(theme.dark)' :key='index')
//-             | {{ key }}
//-         .my-2
//-           v-chip.mx-1(label='' :color='theme.light[key]' v-for='(key, index) in Object.keys(theme.light)' :key='index')
//-             | {{ key }}
</template>
<script>
export default {
  name: 'c_theme_changer',
  data: () => ({
    menu       : false,
    empresaFull: process.env.EMPRESA || 'datacont',
    // empresaFull: 'reprodata',
    themes     : [
      {
        name : 'datacont',
        light: {
          primary   : '#d70b18',
          secondary : '#ffedef',
          error     : '#f14668',
          background: '#ebeff3',
          success   : '#00d370',
          opacity   : '#d70b18c2'
        },
        dark : {
          primary   : '#b80813',
          secondary : '#441115',
          error     : '#f14668',
          background: '#272727',
          success   : '#00d370',
          opacity   : '#b80813cc'
        }
      },
      {
        name : 'reprodata',
        light : {
          primary   : '#e6007e',
          secondary : '#ffedf7',
          error     : '#f14668',
          background: '#ebeff3',
          success   : '#00d370',
          opacity   : '#e6007ecc'
        },
        dark  : {
          primary   : '#e6007e',
          secondary : '#35272f',
          error     : '#f14668',
          background: '#272727',
          success   : '#00d370',
          opacity   : '#e6007ecc'
        }
      }
    ]
  }),
  created () {
    var vm = this
    var thema = vm.themes.find(e => e.name === vm.empresaFull)
    vm.setTheme(thema)
  },
  methods: {
    setTheme (theme) {
      var vm = this
      // cerrar menu
      vm.menu = false;
      var name = theme.name;
      var dark = theme.dark;
      var light = theme.light;
      // establecer temas
      Object.keys(dark).forEach(i => { vm.$vuetify.theme.themes.dark[i] = dark[i] })
      Object.keys(light).forEach(i => { vm.$vuetify.theme.themes.light[i] = light[i] })
      // también guarde el nombre del tema para deshabilitar la selección
      vm.$vuetify.theme.themes.name = name;
    }
  }
};
</script>



// WEBPACK FOOTER //
// c_theme_changer.vue?55b828ca